import {useDefault} from '../../../common/common';
import {FeatureFlag} from '../../model/featureflags/feature-flag.model';
import {FeatureFlags} from '../../model/featureflags/feature-flags.model';
import {FeatureName} from '../../model/featureflags/feature-name.model';

export class FeatureFlagsBuilder {
    private _model: FeatureFlags;

    constructor() {
        this._model = new FeatureFlags();
    }

    withFeatureTogglesData(toggleData: any): FeatureFlagsBuilder {
        const featureTogglesData = useDefault(toggleData, {});
        this._setFlags(featureTogglesData);
        return this;
    };

    private _setFlags(featureTogglesData) {
        const featureNames = Object.keys(FeatureName);

        featureNames.forEach(name => {
            const featureName = FeatureName[name];
            let flag = new FeatureFlag(featureName);
            flag.isActive = Boolean(featureTogglesData[featureName]);
            flag.version = featureTogglesData[featureName];
            this._model.flags.push(flag);
        });
    }

    build(): FeatureFlags {
        return this._model;
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/services/builders/feature-flags.builder.ts